import { RelationTypesGridView } from '~/components/catalog/relation-types';
import { PageContainer } from '~/components/page-container';

export function RelationTypes() {
	return (
		<PageContainer>
			<RelationTypesGridView />
		</PageContainer>
	);
}
